import {createSlice} from "@reduxjs/toolkit";
import type {RootState} from "../../app/store";

interface ForbiddenState {
    isForbidden: boolean;
}

const initialState: ForbiddenState = {
    isForbidden: false,
};

export const forbiddenSlice = createSlice({
    name: "forbidden",
    initialState,
    reducers: {
        setForbidden: (state) => {
            state.isForbidden = true;
        },
        // Optional: Add a reset action if needed, e.g., on logout
        // resetForbidden: (state) => {
        //   state.isForbidden = false;
        // }
    },
});

export const {setForbidden} = forbiddenSlice.actions;

export const selectIsForbidden = (state: RootState) =>
    state.forbidden.isForbidden;

export default forbiddenSlice.reducer;
